import { Keys, locale } from 'src/i18n';

export const getSifgOptionsForProfileSelection = (profiles: any = []) =>
  profiles.map((profile) => ({
    code: profile.type,
    name: profile.name,
  }));

const getCodeNameSpinnerOptionsForProfile = (subType, profile) => {
  switch (subType) {
    case 'phone':
      return (profile.phoneNumbers || []).map((item) => ({
        code: item.value,
        name: `${item.name} - ${item.value}`,
      }));
    case 'location':
      return (profile.locations || []).map((item) => ({
        code: item?.id,
        name: `${item?.name || locale(Keys.NO_NAME)} - ${
          item?.value?.address_string || locale(Keys.NO_ADDRESS_FOUND)
        }`,
      }));
    case 'email':
      return (profile.emailIDs || []).map((item) => ({
        code: item?.id,
        name: item?.value,
      }));
    default:
      return [];
  }
};

const getDefaultValueForProfile = (subType, profile) => {
  switch (subType) {
    case 'phone':
      return (profile.phoneNumbers || []).find((option) => option.isPrimary)
        ?.value;
    case 'location':
      return (profile.locations || []).find((option) => option.isPrimary)?.id;
    case 'email':
      return (profile.emailIDs || []).find((option) => option.isPrimary)?.id;
    default:
      return '';
  }
};

export const getSifgInputsForProfileSelection = (subTypes, profiles = []) =>
  profiles.reduce((acc, profile: any) => {
    if (profile.type) {
      acc[profile.type] = Object.keys(subTypes).map((subType) => ({
        ...subTypes[subType],
        code_name_spinner_options: getCodeNameSpinnerOptionsForProfile(
          subType,
          profile,
        ),
        value: getDefaultValueForProfile(subType, profile),
      }));
    }
    return acc;
  }, {});
